import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    promociones: [],
    descuentos: [],
    pedidosHome: [],
    presupuestosHome: [],
    devolucionesHome: [],
    categorias: [],
    productos: [],
    imagenes: [],
    
    carrito:    JSON.parse(localStorage.getItem('carrito') || '[]'),
    pedidoId:   localStorage.getItem('pedidoId')   || -1,
    borradorId: localStorage.getItem('borradorId') || 0,
    seleccion:  localStorage.getItem('seleccion')  || 0,
    multiploValido:true,
    tipoOperacion: localStorage.getItem('tipoOperacion')  || '',
    idPresupuestoConvertido: localStorage.getItem('idPresupuestoConvertido')   || -1,

  },
  getters: {

    getPromoHome: state => {
      return state.promociones.slice(0, 2)
    },

    getDescuentosHome: state => {
      return state.descuentos.slice(0, 2)
    }

  },
  mutations: {

    savePromociones (state, promociones) {
      state.promociones = promociones
    },

    saveDescuentos (state, descuentos) {
      state.descuentos = descuentos
    },

    savePedidosHome (state, pedidos) {
      state.pedidosHome = pedidos
    },

    savePresupuestosHome (state, p) {
      state.presupuestosHome = p
    },

    saveDevolucionesHome (state, d) {
      state.devolucionesHome = d
    },

    saveCategorias (state, categorias) {
      state.categorias = categorias
    },
  
    saveProductos (state, productos) {
      state.productos = productos
    },

    saveIdPresupuestoConvertido (state, id) {
      state.idPresupuestoConvertido = id
      localStorage.setItem("idPresupuestoConvertido",id);
    },

    agregarAPedido (state, producto) {
      state.carrito.push(producto)
      localStorage.setItem("carrito",JSON.stringify(state.carrito));
    },

    replicarPedido (state, pedido) {
      state.carrito = pedido
    },

    eliminarPromociones (state) {
      state.promociones = []
    },

    eliminarDescuentos (state) {
      state.descuentos = []
    },

    eliminarProductos (state) {
      state.productos = []
    },

    eliminarPedido (state) {
      state.carrito = []
      state.borradorId = 0
      localStorage.removeItem("carrito");
      localStorage.removeItem("borradorId");
    },

    eliminarItemPedido (state, id) {
      var ind = state.carrito.map((el) => el.id).indexOf(id)
      if (ind > -1) {
        Vue.delete(state.carrito, ind)
      }
    },

    updateItemCarrito (state, item) {
      var ind = state.carrito.map((el) => el.id).indexOf(item.id)
      if (ind > -1) {
        Vue.set(state.carrito, ind, item)
      }
    },

    savePedidoId (state, id) {
      state.pedidoId = id
      localStorage.setItem("pedidoId",id);
    },

    saveSucursales (state, sucursales) {
      state.sucursales = sucursales
    },

    setBorradorId (state, id) {
      state.borradorId = id
      localStorage.setItem("borradorId",id);
    },

    setSeleccion (state, selec) {
      state.seleccion = selec
      localStorage.setItem("seleccion",selec);
    },

    saveImage (state, img) {
      state.imagenes.push(img)
    },
    
    saveMultiploValido (state, flag) {
      state.multiploValido = flag
    },

    saveTipoOperacion (state, o) {
      state.tipoOperacion = o
      localStorage.setItem("tipoOperacion",o);
    },


    delete (state) {
      state.promociones   = []
      state.descuentos    = []
      state.pedidosHome   = []
      state.categorias    = []
      state.subcategorias = []
      state.productos     = []
      state.carrito       = []
      state.pedidoId      = -1
      state.borradorId    = 0
      state.seleccion     = 0
      state.imagenes      = []

      localStorage.removeItem("carrito");
      localStorage.removeItem("borradorId");
      localStorage.removeItem("seleccion");
      localStorage.removeItem("pedidoId");
      localStorage.removeItem("tipoOperacion");
      localStorage.removeItem("idPresupuestoConvertido");
    },

  }

}



// WEBPACK FOOTER //
// ./src/store/modules/pedido.js